var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "layout-brand",
    "class": {
      'layout-brand--tabbar': _vm.tabbar
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('img', {
    staticClass: "layout-brand__img",
    attrs: {
      "src": require("../../assets/images/qzz_logo.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "layout-brand__text"
  }, [_vm._v("企增长提供技术支持")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };